<app-header></app-header>

<div class="main-content" style="padding-top: 65px;">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<div [ngClass]="{'loader': loading}"></div>